<div class="dx-card wide-card">
    <h4 class="content-block ap-green">Distributor Referral Maintenance</h4>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="sm">
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-row [ratio]="1"></dxi-row>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-col [ratio]="1"></dxi-col>
            <dxi-item class="marginB10">
                <dxi-location screen="sm md lg" [row]="0" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label">Call Date:</div>
                    <div class="dx-field-value">
                        {{date}}
                    </div>
                </div>
            </dxi-item>
            <dxi-item class="marginB10">
                <dxi-location screen="sm md lg" [row]="0" [col]="1"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label">By:</div>
                    <div class="dx-field-value">
                        {{apexId}}
                    </div>
                </div>
            </dxi-item>

            <dxi-item class="marginB20">
                <dxi-location screen="sm md lg" [row]="1" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"><span class="error">*</span> Post Code</div>
                    <div class="dx-field-value">
                        <dx-text-box name="postCode" placeholder="5 digit US, 6 digit CA as 1A2 3B4"
                            hint="5 digit US, 6 digit CA as 1A2 3B4" [(value)]="postCode">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Post Code is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item class="marginB20 ">
                <dxi-location screen="md lg" [row]="1" [col]="1"></dxi-location>
                <dxi-location screen="sm" [row]="2" [col]="0"></dxi-location>
                <div class="dx-field">
                    <div class="dx-field-label"><span class="error">*</span> Radius (mi)</div>
                    <div class="dx-field-value">
                        <dx-text-box name="miles" [(value)]="radius">
                            <dx-validator>
                                <dxi-validation-rule type="required" message="Radius is required">
                                </dxi-validation-rule>
                            </dx-validator>
                        </dx-text-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item class="marginB20">
                <dxi-location screen="md lg" [row]="1" [col]="2"></dxi-location>
                <dxi-location screen="sm" [row]="3" [col]="0"></dxi-location>
                <div>
                    <dx-button text="Search" stylingMode="contained" (onClick)="search($event)" type="default" [useSubmitBehavior]="true">
                    </dx-button>
                </div>
            </dxi-item>
        </dx-responsive-box>
    </div>
    <dx-data-grid #grid class="fixGridHeight" id="DistributorReferralMaintenanceGrid"
        [dataSource]="distributorReferralMaintenance" [showBorders]="true"
        (onRowInserted)="addDistributorReferralMaintenance($event)" (onInitNewRow)="onInitNewRow($event)"
        (onRowUpdated)="updateDistributorReferralMaintenance($event)" [allowColumnResizing]="true"
        [rowAlternationEnabled]="true" [showRowLines]="true" [showColumnLines]="true" [showBorders]="true"
        keyExpr="distributorId" *ngIf="showGrid" (onSelectionChanged)="selectionChangedHandler()">
        <dxo-filter-row [visible]="false"></dxo-filter-row>
        <dxo-paging [enabled]="true" [pageSize]="20"></dxo-paging>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-scrolling columnRenderingMode="virtual"></dxo-scrolling>
        <dxo-column-fixing [enabled]="true"></dxo-column-fixing>
        <dxo-editing mode="popup" [useIcons]="true" [allowUpdating]="true" [allowAdding]="false">
            <dxo-popup title="Add/Edit Distributor" [showTitle]="true" [toolbarItems]="[  
            {  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Save',  
              icon: '',
              stylingMode:'contained',
              type:'success'
            },  
            toolbar: 'bottom',  
            onClick: onSaveClick  
        },{  
            widget: 'dxButton',  
            location: 'after',  
            options: {  
              text: 'Cancel',  
              icon: ''  ,
              type:'danger'
            },  
            toolbar: 'bottom',  
            onClick: onCancelClick  
        }]">
            </dxo-popup>
            <dxo-form>
                <dxi-item dataField="activeFlag" dataType="boolean"></dxi-item>
                <dxi-item dataField="shipToPartyId"></dxi-item>
                <dxi-item dataField="company"></dxi-item>
                <dxi-item dataField="street"></dxi-item>
                <dxi-item dataField="city"></dxi-item>
                <dxi-item dataField="provinceId" caption="Province" [width]="150">
                    <dxo-lookup [dataSource]="stateProvince" displayExpr="province" valueExpr="provinceId">
                    </dxo-lookup>
                </dxi-item>
                <dxi-item dataField="postCode"></dxi-item>
                <dxi-item dataField="phone"></dxi-item>
                <dxi-item dataField="contactFirstName"></dxi-item>
                <dxi-item dataField="contactLastName"></dxi-item>
                <dxi-item dataField="latitude">
                    <dxi-validation-rule type="range" [max]="90" [min]="-90"
                        message="Latitude must be between -90 and +90">
                    </dxi-validation-rule>
                </dxi-item>
                <dxi-item dataField="longitude">
                    <dxi-validation-rule type="range" [max]="180" [min]="-180"
                        message="Longitude must be between -180 and +180">
                    </dxi-validation-rule>
                </dxi-item>
            </dxo-form>
        </dxo-editing>
        <dxo-toolbar>
            <dxi-item name="groupPanel"></dxi-item>
            <dxi-item location="after">
                <dx-button text="Add" stylingMode="contained" type="default" (onClick)="addRow()"></dx-button>
                <dx-button text="Pick Me" stylingMode="contained" type="default" [disabled]="disablePickMe" (onClick)="pickMe()"></dx-button>
                <dx-button text="Reset" stylingMode="contained" type="default" (onClick)="resetFilters()"></dx-button>
            </dxi-item>
            <dxi-item name="searchPanel"></dxi-item>
        </dxo-toolbar>
        <dxo-pager [visible]="true" [allowedPageSizes]="allowedPageSizes" [showPageSizeSelector]="true"
            [showInfo]="true" [showNavigationButtons]="false"></dxo-pager>
        <dxo-selection mode="multiple"> </dxo-selection>
        <dxi-column type="buttons" [width]="80">
            <dxi-button name="edit"></dxi-button>
        </dxi-column>
        <dxi-column dataField="miles" [allowEditing]="false" [width]="150"></dxi-column>
        <dxi-column dataField="shipToPartyId" [visible]="false" [width]="150"></dxi-column>
        <dxi-column dataField="company" [width]="350"></dxi-column>
        <dxi-column dataField="street" [width]="250"></dxi-column>
        <dxi-column dataField="city" [width]="150"></dxi-column>
        <dxi-column dataField="provinceId" caption="Province" [width]="150">
            <dxo-lookup [dataSource]="stateProvince" displayExpr="province" valueExpr="provinceId">
            </dxo-lookup>
        </dxi-column>
        <dxi-column dataField="postCode" [width]="150"></dxi-column>
        <dxi-column dataField="phone" [width]="150"></dxi-column>
        <dxi-column dataField="contactName" [width]="250"></dxi-column>
        <dxi-column dataField="latitude" dataType="string" [width]="120"></dxi-column>
        <dxi-column dataField="longitude" dataType="string" [width]="120"></dxi-column>
        <dxi-column dataField="modifiedBy" [width]="150"></dxi-column>
        <dxi-column dataField="modifiedDate" [width]="150"></dxi-column>
        <dxi-column dataField="insertedBy" [width]="150"></dxi-column>
        <dxi-column dataField="insertedDate" [minWidth]="150"></dxi-column>
        <dxi-column dataField="contactFirstName" [visible]="false" [minWidth]="150"></dxi-column>
        <dxi-column dataField="contactLastName" [visible]="false" [minWidth]="150"></dxi-column>
        <dxi-column dataField="activeFlag" [visible]="false"></dxi-column>
    </dx-data-grid>
    <dx-load-panel #dxLoadPanel shadingColor="rgba(0,0,0,0.4)" [visible]="isLoadPanelVisible" [showPane]="true"
        [shading]="false" [closeOnOutsideClick]="false">
    </dx-load-panel>
</div>